.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 0 0 var(--headers-margin-bottom) 0;
    padding: 0;
}

h1,
.h1 {
    font: var(--h1-typography);
}

h2,
.h2 {
    font: var(--h2-typography);
}

h3,
.h3 {
    font: var(--h3-typography);
}

h4,
.h4 {
    font: var(--h4-typography);
}

h5,
.h5 {
    font: var(--h5-typography);
}

h6,
.h6 {
    font: var(--h6-typography);
}

@media (max-width: 768px) {

    h1,
    .h1 {
        font: var(--h1-typography-medium-only);
    }

    h2,
    .h2 {
        font: var(--h2-typography-medium-only);
    }

    h3,
    .h3 {
        font: var(--h3-typography-medium-only);
    }

    h4,
    .h4 {
        font: var(--h4-typography-medium-only);
    }

    h5,
    .h5 {
        font: var(--h5-typography-medium-only);
    }

    h6,
    .h6 {
        font: var(--h6-typography-medium-only);
    }
}

@media (max-width: 480px) {

    h1,
    .h1 {
        font: var(--h1-typography-small-only);
    }

    h2,
    .h2 {
        font: var(--h2-typography-small-only);
    }

    h3,
    .h3 {
        font: var(--h3-typography-small-only);
    }

    h4,
    .h4 {
        font: var(--h4-typography-small-only);
    }

    h5,
    .h5 {
        font: var(--h5-typography-small-only);
    }

    h6,
    .h6 {
        font: var(--h6-typography-small-only);
    }
}